<ng-container *transloco="let t;">
  <div class="px-4 md:px-6 lg:px-8">
    <div class="py-6 flex flex-column sm:flex-row sm:align-items-center justify-content-between">
      <div>
        <div class="mt-2 line-height-3">{{ t('footer', {year: currentYear | date : 'yyyy', version: appVersion}) }}</div>
      </div>
    </div>
  </div>
</ng-container>